import { zodResolver } from '@hookform/resolvers/zod'
import { initialSimpleTaskPayload } from 'aos-services/src/services/tasks/types'
import React, { createContext, PropsWithChildren, useContext, useMemo } from 'react'
import { FormProvider, useForm, UseFormReturn } from 'react-hook-form'

import { taskFormSchema, TaskOrTemplatePayload } from '../utils'

const TasksFormMethodsContext = createContext<UseFormReturn<TaskOrTemplatePayload> | null>(null)

export function TasksFormRoot({ children }: PropsWithChildren) {
    const methods = useForm<TaskOrTemplatePayload>({
        defaultValues: initialSimpleTaskPayload,
        mode: 'onSubmit',
        reValidateMode: 'onChange',
        resolver: zodResolver(taskFormSchema),
    })

    const value = useMemo(() => methods, [methods])

    return (
        <TasksFormMethodsContext.Provider value={value}>
            {children}
        </TasksFormMethodsContext.Provider>
    )
}

export function TasksFormProvider({ children }: PropsWithChildren) {
    const methods = useContext(TasksFormMethodsContext)
    if (!methods) {
        throw new Error('TasksFormProvider must be used under TasksFormRoot')
    }

    return <FormProvider {...methods}>{children}</FormProvider>
}
